import * as React from "react";
import { useLocation } from "react-router-dom";

import { checkLinkValid } from "../../../services/apiAuth";

export function useResetPasswordLinkValidation() {
  const { search } = useLocation();
  const uuid = React.useMemo(() => {
    const urlParams = new URLSearchParams(search);
    return urlParams.get("uuid");
  }, [search]);

  const [email, setEmail] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [isLinkValid, setIsLinkValid] = React.useState(null);

  React.useEffect(() => {
    if (!uuid) {
      setIsLinkValid(false);
      setIsLoading(false);
      return;
    }

    checkLinkValid(uuid)
      .then((res) => {
        const responseData = res?.data?.data?.responseData || {};
        setEmail(responseData.email || "");
        setIsLinkValid(responseData.link_valid);
      })
      .catch((error) => {
        console.log(error);
        setIsLinkValid(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [uuid]);

  return {
    uuid,
    email,
    isLoading,
    isLinkValid,
  };
}
